export default __webpack_public_path__ + "dab1d47f3075e6c00899b93bc5029023.png";